import { type CSSProperties } from "react";
import { Input, InputProps } from "antd";
import "./input-search.scss";
import { SearchIcon } from "@/shared/assets/svg/icons";

interface IInputSearch extends InputProps {
  placeholder?: string;
  style?: CSSProperties;
}

export const InputSearch = ({
  placeholder = "Поиск",
  style,
  ...rest
}: IInputSearch) => {
  return (
    <Input
      placeholder={placeholder}
      suffix={<SearchIcon />}
      className="input-search-container"
      style={style}
      {...rest}
    />
  );
};
